<template>
  <b-overlay :show="showOverlay">

    <div v-if="pageData && pageData.value">
      <b-card>
        <language-picker
            @getLanguage="setLanguage"
        ></language-picker>
      </b-card>
      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Edit meta descriptions</h1>
          </b-col>

          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="home"
                label-for="home"
            >
              <b-form-textarea
                  id="home"
                  v-model="pageData.value.home.metDescription"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="blogs"
                label-for="blogs"
            >
              <b-form-textarea
                  id="blogs"
                  v-model="pageData.value.blogs.metDescription"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="products"
                label-for="products"
            >
              <b-form-textarea
                  id="products"
                  v-model="pageData.value.products.metDescription"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="aboutUs"
                label-for="aboutUs"
            >
              <b-form-textarea
                  id="aboutUs"
                  v-model="pageData.value.aboutUs.metDescription"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="contactUs"
                label-for="contactUs"
            >
              <b-form-textarea
                  id="contactUs"
                  v-model="pageData.value.contactUs.metDescription"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="prices"
                label-for="prices"
            >
              <b-form-textarea
                  id="prices"
                  v-model="pageData.value.prices.metDescription"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="search"
                label-for="search"
            >
              <b-form-textarea
                  id="search"
                  v-model="pageData.value.search.metDescription"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col class="my-2" cols="12">
            <b-button class="btn" type="button" variant="primary" @click="updateFooter">Submit changes</b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCarousel,
  BCarouselSlide,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {DynamicPagesGetBy, DynamicPagesGetByType, UpdateDynamicPages} from "@/libs/Api/DynamicPages";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";

export default {
  name: "metaDescriptions",
  title: "Meta descriptions",
  data() {
    return {
      showOverlay: false,
      languageList:[],
      rawHTML: '',
      languageId:1,
      pageData: null,
    }
  },
  watch: {
    languageId: {
      handler(val) {
        this.getPageData();
      },
    },
  },
  async created() {
    await this.getPageData();
  },
  methods: {
    async getPageData() {
      let _this = this;
      _this.showOverlay = true;

      let dynamicPagesGetBy = new DynamicPagesGetByType(_this);
      dynamicPagesGetBy.setParams({
        type: 7,
        LanguageId:_this.languageId
      })
      await dynamicPagesGetBy.fetch(function (content) {
        _this.showOverlay = false;
        _this.pageData = content.data;
        _this.pageData.value = JSON.parse(_this.pageData.value);
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async updateFooter() {
      let _this = this;
      _this.showOverlay = true;

      let updateDynamicPages = new UpdateDynamicPages(_this);
      // _this.pageData.value['address'] = '';
      _this.pageData.value = JSON.stringify(_this.pageData.value);
      updateDynamicPages.setParams(_this.pageData);
      await updateDynamicPages.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Operation successful`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.getPageData();
      }, function (error) {
        console.log(error);
        _this.showOverlay = false;
      })
    },
    setLanguage(language) {
      this.languageId = language.languageId;
    },
    setEditorContent(content) {
      this.pageData.value.customFooter = content;
    },
    setEditorContentMobile(content) {
      this.pageData.value.customFooterMobile = content;
    },
  },
  components: {
    LanguagePicker,
    AddEditDeleteButton,
    ValidationProvider,
    AppCollapse,
    AppCollapseItem,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BFormFile,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BCarousel,
    BCarouselSlide,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BOverlay,
    BModal,
    BFormSelect,
    vSelect,
    BFormTextarea,
  },
}
</script>

<style scoped>

</style>
